<template>
<section
    class="search-section"
    :class="{ 'search-section-divided': divided }"
    :aria-labelledby="headingId"
>
    <div class="section-heading">
        <h2 :id="headingId">{{ section.title }}</h2>
        <span v-if="section.status === 'loading'" class="section-state">Ищем…</span>
        <span v-else-if="section.status === 'success'" class="section-count">{{ section.results.length }}</span>
    </div>

    <p v-if="section.status === 'error'" class="section-message" role="alert">{{ section.error }}</p>
    <p v-else-if="section.status === 'success' && !section.results.length" class="section-message">Ничего не найдено</p>

    <div v-if="section.results.length" class="section-results">
        <router-link
            v-for="item in section.results"
            :key="item.key"
            class="result"
            :to="resultRoute(item)"
            :aria-label="`Открыть ${item.title}`"
            @click="$emit('select')"
        >
            <PosterImage class="poster unselectable" :src="item.poster" alt=""/>
            <div class="data">
                <span class="main">{{ item.title }}</span>
                <span v-if="item.subtitle" class="desc">{{ item.subtitle }}</span>
            </div>
        </router-link>
    </div>
</section>
</template>

<script>
import PosterImage from '@/components/PosterImage.vue'
import { mediaRoute } from '@/utils/media.js'

export default {
    name: 'SearchSection',
    components: { PosterImage },
    emits: ['select'],
    props: {
        section: {
            type: Object,
            required: true,
        },
        divided: Boolean,
    },
    computed: {
        headingId() {
            return `search-section-${this.section.id}`
        },
    },
    methods: {
        resultRoute(item) {
            return mediaRoute(item)
        },
    },
}
</script>

<style scoped>
.search-section {
    min-width: 0;
}
.search-section-divided {
    margin-top: 12px;
    padding-top: 13px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.section-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 25px;
    padding: 0 8px 5px;
}
h2 {
    margin: 0;
    color: #fff;
    font: 600 13px/1.2 Inter, sans-serif;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}
.section-state,
.section-count {
    color: #a9a9a9;
    font: 12px/1.2 Inter, sans-serif;
}
.section-count {
    min-width: 22px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    padding: 3px 7px;
    box-sizing: border-box;
    text-align: center;
}
.section-results {
    display: grid;
    gap: 6px;
}
.section-message {
    margin: 2px 8px 7px;
    color: #bdbdbd;
    font: 13px/1.4 Inter, sans-serif;
}
.result {
    display: grid;
    grid-template-columns: 49px minmax(0, 1fr);
    align-items: center;
    gap: 12px;
    width: 100%;
    min-width: 0;
    padding: 8px;
    box-sizing: border-box;
    border-radius: 10px;
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    transition: background 160ms ease;
}
.result:hover { background: rgba(255, 255, 255, 0.08); }
.result:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.9);
    outline-offset: -2px;
}
.poster {
    width: 49px;
    height: 71px;
    flex-shrink: 0;
    border-radius: 4px;
}
.data {
    width: 100%;
    min-width: 0;
}
.main {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    color: #fff;
    font: 18px/1.2 Inter, sans-serif;
}
.desc {
    display: block;
    overflow: hidden;
    color: #c2c2c2;
    font: 14px/1.3 Inter, sans-serif;
    margin-top: 6px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

@media (prefers-reduced-motion: reduce) {
    .result { transition: none; }
}
</style>
